// @flow
import { all, call, put, select, takeEvery } from 'redux-saga/effects';
import { CommonActions } from '@react-navigation/native';
import { hasCustomerIdentificationSelector } from '../Customer/selectors';
import { initializeSignUp } from '../SignUp/sagas';
import TrpcLibrary from 'digicel-kaizen-library/lib/tripica-library';
import Navigation, { getActivationInitialRouteName, resetToPath } from '../../lib/navigation';
import {ALLOWED_REDIRECT_PATHS} from '../../lib/allowedRedirectPaths';
import { isLoggedInSelector } from '../Authentication';
import type { Action } from './actions';
import { fetchDashboardDataSaga } from '../Dashboard';
import { AuthenticationTokenManager } from '../../api';
import { setLoading } from '../LoadingStatus/actions';
import WizzeeLog from '../../lib/wizzeeLog';

export function* goToSignUp(): Generator<*, *, *> {
  const isLoggedIn = yield select(isLoggedInSelector);
  if (!isLoggedIn) {
    return yield call(Navigation.dispatch, CommonActions.navigate({ name: 'requiredToSignUp' }));
  }
  if (!!TrpcLibrary.getRegions()) {
    return yield call(initializeSignUp, { type: 'SIGNUP_INIT' }, 'chooseRegion');
  }
  return yield call(initializeSignUp, { type: 'SIGNUP_INIT' }, 'choosePlan');
}

export function* goToSimActivation(): Generator<*, *, *> {
  const hasIdentification = yield select(hasCustomerIdentificationSelector);
  hasIdentification
    ? yield call(Navigation.dispatch, CommonActions.navigate({ name: 'simCardManual' }))
    : yield call(Navigation.dispatch, CommonActions.navigate({ name: getActivationInitialRouteName() }));
}

export function* goToInviteAFriend(): Generator<*, *, *> {
  yield call(Navigation.dispatch, CommonActions.navigate({ name: 'inviteFriend' }));
}

export function* redirectAfterLoginSaga(action: Action): Generator<*, *, *> {
  if (action.type !== 'REDIRECT_AFTER_LOGIN') return; // for flow
  yield put(setLoading('redirectAfterLogin', true));

  try {
    const { redirectPath } = action.payload;
    const token = yield call(AuthenticationTokenManager.get);
    if (token && ALLOWED_REDIRECT_PATHS.includes(redirectPath)) {
      yield call(fetchDashboardDataSaga);
      yield call(resetToPath, redirectPath);
    }
  } catch (error) {
    WizzeeLog.warn('[saga] redirectAfterLoginSaga: ', error);
  } finally {
    yield put(setLoading('redirectAfterLogin', false));
  }
}

export default function*(): Generator<*, *, *> {
  yield all([
    takeEvery('GO_TO_SIGN_UP', goToSignUp),
    takeEvery('GO_TO_SIM_ACTIVATION', goToSimActivation),
    takeEvery('GO_TO_INVITE_A_FRIEND', goToInviteAFriend),
    takeEvery('REDIRECT_AFTER_LOGIN', redirectAfterLoginSaga),
  ]);
}
